<template>

        <div class="flex-grid m-div-table__holder-section">
            <div class="flex-grid__g-3 hide">
                <h3 class="heading">{{title}}</h3>
                {{subtitle}}
            </div>

            <div class="flex-grid__g-3">
                <h2 class="heading">Benefit Amount</h2>
                <control before-after="pound" :table-control="true">
                    <input autocomplete="off" v-model.number="amount"
                        v-field-control.required="{type: 'number'}"
                        v-on:focus="amount = amount || ''"
                        v-on:blur="amount = amount || 0"
                        v-two-dp
                        min="0.00"
                        :name="fieldName+'_value'"
                        type="number">
                    <control-error :show="$error(fieldName+'_value')">
                        The amount cannot be below 0 and must be a number.
                    </control-error>
                </control>
            </div>

            <div class="flex-grid__g-3">
                <h2 class="heading">Deduction</h2>
                <control :table-control="true">
                    <select v-model="include">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                    </select>
                </control>
            </div>
        </div>

</template>

<script>
    import FormValidator from 'components/form/validator/mixin';
    import _ from 'lodash';
    import Control from 'components/form/Control';
    import ControlError from 'components/form/control/Error';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    export default {
        name: "benefit",
        mixins: [
            FormValidator
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        components: {
            Control,
            ControlError,
        },
        props: {
            title: {
                type: String,
                required: true
            },
            storeKey: {
                type: String,
                required: true
            },
            subtitle: {
                type: String,
                default: ''
            },
            showHeader: {
                type: Boolean,
                default: false
            },
            isLast: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            fieldName() {
                return _.snakeCase(this.title)
            },
            benefit() {
                return this.$store.getters['lost/cruBenefits/' + this.storeKey];
            },
            amount: {
                get() {
                    return this.benefit.value;
                },
                set(value) {
                    this.updateValue({key: this.storeKey, value})
                        .then(this.calcInterest);
                }
            },
            include: {
                get() {
                    return this.benefit.include;
                },
                set(value) {
                    this.updateInclude({key: this.storeKey, value})
                        .then(this.calcInterest);
                }
            }
        },
        methods: {
            calcInterest(){
                return this.$store.dispatch('lost/headsOfLoss/calcAllInterest');
            },
            updateValue(arg){
                return this.$store.dispatch('lost/cruBenefits/updateValue', arg);
            },
            updateInclude(arg){
                return this.$store.dispatch('lost/cruBenefits/updateInclude', arg);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Benefit.vue?1c769938